import { InputText } from 'primereact/inputtext'

import { FieldWrapper } from './FieldWrapper'

export const NumberField = ({
  id,
  label,
  value = '',
  onChange,
  onBlur,
  required,
  disabled,
  helper,
  error,
  diffStatus,
  ai = false,
  maxLength,
  placeholder,
  inputRef
}) => (
  <FieldWrapper
    id={id}
    label={label}
    required={required}
    helper={helper}
    error={error}
    diffStatus={diffStatus}
    ai={ai}
    disabled={disabled}
  >
    <InputText
      id={id}
      ref={inputRef}
      value={value ?? ''}
      onChange={(e) => onChange?.(e.target.value)}
      onBlur={onBlur}
      disabled={disabled}
      maxLength={maxLength}
      placeholder={placeholder}
      keyfilter="int"
      inputMode="numeric"
      aria-invalid={error ? 'true' : 'false'}
      className={error ? 'p-invalid' : ''}
    />
  </FieldWrapper>
)
